/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      // Go to prev page
      $( '.quoter-nav .quoter-back' ).click( function() {
        $( '.current-page .gform_previous_button' ).trigger( 'click' );
      } );

      // Go to prev page
      $( '.quoter-nav .quoter-next' ).click( function() {
        if ( $( '.current-page .gform_page_footer input[type="submit"]' ).length ) {
          $( '.current-page .gform_page_footer input[type="submit"]' ).trigger( 'click' );
        } else {
          $( '.current-page .gform_next_button' ).trigger( 'click' );
        }
      } );

      // Set Current Page
      $( '.quoter-skin .gform_page:first-child' ).addClass( 'current-page' ).attr( 'tabindex', '0' );

      // Set progress
      const totalPages = $( '.quoter-page .gform_body .gform_page' ).length;
      const progress = ( 1 / totalPages ) * 100;
      let valueChanged = false;
      $( '.quoter-page .progress-bar .progress' ).css( {
        'width': progress + '%',
      } );

      $( '.start-quoter' ).click( function() {
        $( '.intro-area' ).addClass( 'is-inactive' );
        $( '.quoter-area' ).addClass( 'is-active' );
      } );

      // Page change stuff
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const progress = ( currentPage / totalPages ) * 100;
        valueChanged = false;

        $( '.quoter-nav .quoter-next' ).addClass( 'is-inactive' );
        $( '#gform_page_' + formId +'_' + currentPage + ' .gfield' ).each( function() {
          if ( $( this ).find( 'input[type="text"], input[type="radio"]:checked, input[type="checkbox"]:checked, select, textarea' ).val() ) {
            $( '.quoter-nav .quoter-next' ).removeClass( 'is-inactive' );
          }
        } );

        $( '.quoter-page .progress-bar .progress' ).css( {
          'width': progress + '%',
        } );

        // Update quoter nav
        if ( currentPage > 1 ) {
          $( '.quoter-nav .quoter-back' ).removeClass( 'is-inactive' );
        } else {
          $( '.quoter-nav .quoter-back' ).addClass( 'is-inactive' );
        }

        // Set current page, scroll to top
        $( '.quoter-skin .gform_page' ).removeClass( 'current-page' );
        $( '#gform_page_' + formId +'_' + currentPage ).addClass( 'current-page' ).attr( 'tabindex', '0' );
        $( '.current-page' ).focus();

        if ( window.innerWidth > 1023 ) {
          $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );
        } else {
          $( 'html, body' ).animate( {scrollTop: $( '.quoter-skin' ).position().top}, 'slow' );
        }

        if ( currentPage == $( '.quoter-skin .gform_page' ).length ) {
          $( '.quoter-nav .quoter-next' ).addClass( 'is-finishing' );
        } else {
          $( '.quoter-nav .quoter-next' ).removeClass( 'is-finishing' );
        }
      } );

      $( document ).on( 'change', '.current-page input, .current-page select', function() {
        if ( !valueChanged ) {
          $( '.quoter-nav .quoter-next' ).removeClass( 'is-inactive' );
          valueChanged = true;
        }
      } );

      // Hide quoter nav on submit
      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        if ( formId == $( '.quoter-page' ).attr( 'data-form' ) ) {
          $( '.quoter-page .quoter-nav, .quoter-save' ).hide();
          $( '.gform_confirmation_message' ).attr( 'tabindex', '0' ).focus();
        }
      } );

      $( document ).on( 'change', '.current-page input[type="radio"]', function() {
        if ( $( '.current-page' ).find( '.section-start .gfield' ).length == 1 ) {
          $( '.current-page .gform_next_button' ).trigger( 'click' );
        }
      } );

      $( document ).on( 'click', '.current-page input[type="radio"]:checked ~ label', function() {
        if ( $( '.current-page' ).find( '.section-start .gfield' ).length == 1 ) {
          $( '.current-page .gform_next_button' ).trigger( 'click' );
        }
      } );

      if ( $( '.gform_save_link' ).length ) {
        $( '.quoter-nav' ).addClass( 'has-save' );
        $( '.quoter-save' ).text( $( '.gform_page:first-child .gform_save_link' ).text() );
      }

      $( '.quoter-save' ).on( 'click', function() {
        $( '.llgq-current-page .gform_save_link' ).trigger( 'click' );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'quoter', COMPONENT );
} )( app );
